import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title } from '@/components/Elements/Title/Title';
import styles from './sso-callback.module.scss';
import {
  InlineNotification,
  NotificationType,
} from '@spotted-zebra-uk/ui-components';
import { Loader } from '@spotted-zebra-uk/ui-components';
import { routes } from '@/constants/routes';
import { AUTH_CODE, EMAIL } from '@/constants/authentication';
import { useRedirect } from '@/hooks/useRedirect';
import { useRedirectAppRouter } from '@/hooks/useRedirectAppRouter';
import {
  clearIndirectInvParamsFromLocalStorage,
  getIndirectInvParamsFromLocalStorage,
} from '@/utils/auth';

const SSOCallbackPage = () => {
  const redirectFromLocalStorage = useRedirect();

  const router = useRedirectAppRouter();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const authCode = searchParams.get('authCode');

  const redirectToLoginWithEmail = () => {
    const email = localStorage.getItem(EMAIL);
    router.pushWithRedirectAppParam(
      routes.login,
      email ? { email } : undefined
    );
  };

  useEffect(() => {
    // Not logged in
    if (!authCode) {
      redirectToLoginWithEmail();
      return;
    }

    localStorage.setItem(AUTH_CODE, authCode);
    const { projectId, stageId, hms } = getIndirectInvParamsFromLocalStorage();

    // Indirect invite flow
    // User has landed on auth before this (saved url params local storage for this exact moment)
    // In the future we should extract those fields from URL (and should come from SSO callback URL)
    if (projectId && stageId) {
      clearIndirectInvParamsFromLocalStorage();
      redirectFromLocalStorage({
        redirectPath: `/inv?project=${projectId}&stageId=${stageId}${
          hms ? `&hms=${hms}` : ''
        }`,
      });
      return;
    }

    redirectFromLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section>
      <Title title={t('ssoCallback.title')} className={styles.title} />
      <InlineNotification notificationType={NotificationType.NEUTRAL}>
        <div className={styles.notificationBody}>
          <p>{t('ssoCallback.weAreConfirming')}</p>
          <p>{t('ssoCallback.pleaseHoldMoment')}</p>
        </div>
      </InlineNotification>
      <div className={styles.loader}>
        <Loader variant="bubbles" />
      </div>
    </section>
  );
};

export default SSOCallbackPage;
